// extracted by mini-css-extract-plugin
export default {"form":"TranslationWhoWeAreDescriptionForm_form__vREPy","form-group":"TranslationWhoWeAreDescriptionForm_form-group__DWY-J"};